export async function copyToClipboard(val, onSuccess, onFail) {
  try {
    await navigator.clipboard.writeText(val);
    typeof onSuccess === 'function' && onSuccess();
  } catch (e) {
    typeof onFail === 'function' && onFail(e);
  }
}
